/**
 * Shared helpers for rendering EBA Single Rulebook Q&A metadata in the
 * finding detail view and focus modal. Lives here (rather than inlined
 * in each component) so a fix to one applies to both.
 */

function isMeaningful(value: string | undefined | null): value is string {
  if (!value) return false;
  const lower = value.toLowerCase().trim();
  return lower !== '' && lower !== 'unknown' && lower !== 'unknown_document' && !lower.startsWith('unknown');
}

/** Trim, drop empties, and de-duplicate while preserving order. */
export function compactList(values: Array<string | undefined | null>): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  values.forEach((value) => {
    const trimmed = value?.trim();
    if (!trimmed || seen.has(trimmed)) return;
    seen.add(trimmed);
    out.push(trimmed);
  });
  return out;
}

/** Render an ISO `YYYY-MM-DD` date as `28 Oct 2016`; pass through other strings. */
export function formatQaDate(value: string | undefined | null): string | undefined {
  if (!isMeaningful(value)) return undefined;
  const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return value.trim();
  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
